import { render, staticRenderFns } from "./wtWallpaperAsset.component.vue?vue&type=template&id=cab524d2&"
import script from "./wtWallpaperAsset.component.vue?vue&type=script&lang=js&"
export * from "./wtWallpaperAsset.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports